// extracted by mini-css-extract-plugin
export default {"Container":"SearchComponentWrapper_Container__3jGx9"};